import { render, staticRenderFns } from "./DtEvalAdmin.vue?vue&type=template&id=64aedc08&scoped=true&"
import script from "./DtEvalAdmin.vue?vue&type=script&lang=js&"
export * from "./DtEvalAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DtEvalAdmin.vue?vue&type=style&index=0&id=64aedc08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aedc08",
  null
  
)

export default component.exports